<div class="animated fadeIn fast">
  <div class="row row-margin row-check text-center">
    <img src="assets/images/pages/create-success.png" alt="Creación exitosa" />
  </div>
  <div class="row row-margin text-center">
    <p class="success-message">
      Estimado, ha sido
      <b class="primary">creada con éxito la clave de acceso</b> para la
      extranet.
    </p>
  </div>
  <div class="row row-margin row-check">
    <button class="button-continue center-block" [routerLink]="['/login']">
      Ir al Login
    </button>
  </div>
</div>
